import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import PHome from './views/pc/Home.vue'
import MHome from './views/mobile/Home.vue'
import Main from './views/Main.vue'
import echarts from './views/charts/echarts.vue'
import Stock from './views/stock/Stock.vue'
import StockIn from './views/stock/StockIn.vue'
import Goods from './views/goods/Goods.vue'
import Order from './views/order/Order.vue'
import CashierCheck from './views/cashier/CashierCheck.vue'
import CheckList from './views/cashier/CheckList.vue'
import Cashier from './views/cashier/Cashier.vue'
import Provider from './views/provider/Provider.vue'
import Demander from './views/demander/Demander.vue'
import Demander1 from './views/demander/Demander1.vue'
import Employee from './views/employee/Employee.vue'
import Cookies from 'js-cookie';


let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    // {
    //     path: '/',
    //     redirect: '/order',
    //     hidden: true
    // },
    {
        path: '/',
        redirect: to => {
            const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
            return isMobile ? '/mobile' : '/order';
        },
        hidden: true
    },
    {
        path: '/goods',
        component: PHome,
        name: '商品管理',
        iconCls: 'fa fa-shopping-cart',//图标样式class
        redirect: '/goods/list',
        children: [
            { path: '/goods/list', component: Goods, name: '商品列表' },
        ]
    },
    // {
    //     path: '/cashier',
    //     component: PHome,
    //     name: '收银管理',
    //     iconCls: 'fa fa-money',//图标样式class
    //     redirect: '/cashier/list',
    //     children: [
    //         { path: '/cashier/list', component: Cashier, name: '收银' },
    //         // { path: '/cashier/check', component: CashierCheck, name: '每日收银盘点' },
    //         // { path: '/cashier/checklist', component: CheckList, name: '盘点记录' },
    //     ]
    // },
    {
        path: '/order',
        component: PHome,
        name: '销货单管理',
        iconCls: 'fa fa-th-list',//图标样式class
        redirect: '/order/list',
        children: [
            { path: '/order/add', component: Cashier, name: '销货单开具' },
            { path: '/order/list', component: Order, name: '销货单列表' },
        ]
    },
    {
        path: '/mobile',
        component: MHome,
        name: '商品查询',
        hidden: true
    },
    {
        path: '/stock',
        hidden: Cookies.get('user_type')==0,
        component: PHome,
        name: '库存管理',
        iconCls: 'fa fa-cubes',//图标样式class
        redirect: '/stock/list',
        children: [
            { path: '/stock/in', component: StockIn, name: '入库' },
            { path: '/stock/list', component: Stock, name: '入库单' },
            
        ]
    },
    {
        path: '/provider',
        component: PHome,
        name: '采购信息管理',
        iconCls: 'fa fa-address-book',//图标样式class
        redirect: '/demander/list',
        children: [
            { path: '/demander/list', component: Demander, name: '需求公司管理' },
            { path: '/demander1/list', component: Demander1, hidden: Cookies.get('user_type')==0, name: '供应商管理' },
            { path: '/provider/list', component: Provider, name: '公司管理' },
        ]
    },
    {
        path: '/employee',
        hidden: Cookies.get('user_type')==0,
        component: PHome,
        name: '员工管理',
        iconCls: 'fa fa-group',//图标样式class
        redirect: '/employee/list',
        children: [
            { path: '/employee/list', component:Employee, name: '员工列表' },
        ]
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;